<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-1/4 form-group w-full">
        <vx-card>
          <div class="con-ul-tabs">
            <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
              <li
                class="vs-tabs--li activeChild"
                v-bind:class="[display_tab == 'company'?'default-active':'']"
              >
                <button type="button" class="vs-tabs--btn text-start" @click="display_tab = 'company'">
                  <span>Company Details</span>
                </button>
              </li>
              <li
                class="vs-tabs--li activeChild"
                v-bind:class="[display_tab == 'account'?'default-active':'']"
              >
                <button type="button" class="vs-tabs--btn text-start" @click="display_tab = 'account'">
                  <span>Account &amp; Billing</span>
                </button>
              </li>
              <li
                class="vs-tabs--li activeChild"
                v-bind:class="[display_tab == 'leavetype'?'default-active':'']"
              >
                <button type="button" class="vs-tabs--btn text-start" @click="display_tab = 'leavetype'">
                  <span>Leave Type</span>
                </button>
              </li>
            </ul>
            <span
              class="line-vs-tabs"
              style="left: 0px; width: 2px; height: 51px; transform: scaleX(1); top: 0px;"
            ></span>
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-3/4 form-group w-full">
        <company v-if="display_tab == 'company'"></company>
        <account v-if="display_tab == 'account'"></account>
        <leavetype v-if="display_tab == 'leavetype'"></leavetype>
      </div>
    </div>
    <vs-popup class="text-center payment-popup" title="Payment Status" :active.sync="paymentPopUp" :button-close-hidden="true">
      <div v-if="this.payment_result == 'success'">
        <feather-icon  icon="CheckCircleIcon" class="payment-check text-success"></feather-icon>
        <h2 class="p-2 font-bold text-success" v-if="this.payment_result == 'success'">Payment Complete</h2>
        <h6 class="p-2">Thank you for subscribe plan.</h6>
      </div>
      <div v-if="this.payment_result == 'failed'">
        <feather-icon icon="AlertCircleIcon" class="payment-check text-danger"></feather-icon>
        <h2 class="p-2 font-bold text-danger" v-if="this.payment_result == 'success'">Payment Faild</h2>
        <h6 class="p-2">Transaction failed. please try again!</h6>
      </div>

      <div class="text-center">
        <vs-button class="pay-with-stripe mt-5" type="gradient" @click.prevent="closePaymentPopup(payment_result)">OK</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import company from "./settings/v2/company";
import account from "./settings/v2/account";
import leavetype from "./settings/leavetype";

export default {
  components: {
    company,
    account,
    leavetype
  },
  data() {
    return {
      display_tab: 'company',
      company: true,
      account: false,
      leavetype: false,
      payment_result: null,
      paymentPopUp: null,
      payment_map_id: false,
    };
  },
  watch: {
    company(val) {
      if (val == true) {
        this.account = false;
        this.leavetype = false;
      }
    },
    account(val) {
      if (val == true) {
        this.company = false;
        this.leavetype = false;
      }
    },
    leavetype(val) {
      if (val == true) {
        this.company = false;
        this.account = false;
      }
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.subcription == "account") {
      this.display_tab = 'account';
      this.account = true;
    }
    if (this.$route.query.paymentResult && this.$route.query.stripe_plan_id && this.$route.query.map_id ) {
      this.paymentPopUp = true;
      this.payment_result = this.$route.query.paymentResult;
      this.payment_map_id = this.$route.query.map_id;
    }
    if (this.$store.state.uInfo.is_plan_expire) {
      this.display_tab = 'account';
    }
    if (this.$store.state.uInfo.is_first_time_login) {
     this.display_tab = 'company';
    }
  },
  methods: {
    /*newSubscribePlan() {
      let query = this.$route.query;
      let input = {
        stripe_plan_id: query.stripe_plan_id,
        plan_id: query.plan_id,
        period: query.period
      };
      this.axios
        .post("newSubcription", input)
        .then(response => {
          let data = response.data.data;
          this.button_loader(false, "#data-addupdate");
          let text = "New plan subscribed successfully";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          let userStoreInfo = this.$store.state.uInfo;
          userStoreInfo.balance = data.loginUser.balance;
          userStoreInfo.card_details = data.loginUser.card_details;
          userStoreInfo.payment_plan = data.loginUser.payment_plan;
          userStoreInfo.is_plan_expire = data.loginUser.is_plan_expire;
          userStoreInfo.stripe_plan_id = data.loginUser.stripe_plan_id;

          localStorage.setItem("user", JSON.stringify(userStoreInfo));
          this.$store.dispatch("updateUser", userStoreInfo);

          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e, "#data-addupdate");
        });
    },
    upgradePlan() {
      let query = this.$route.query;
      let input = {
        stripe_plan_id: query.stripe_plan_id,
        plan_id: query.plan_id,
        period: query.period
      };
      this.axios
        .post("upgrade", input)
        .then(response => {
          let data = response.data.data;
          let text = "Plan upgraded successfully";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          let userStoreInfo = this.$store.state.uInfo;
          userStoreInfo.balance = data.loginUser.balance;
          userStoreInfo.card_details = data.loginUser.card_details;
          userStoreInfo.payment_plan = data.loginUser.payment_plan;
          userStoreInfo.is_plan_expire = data.loginUser.is_plan_expire;
          userStoreInfo.stripe_plan_id = data.loginUser.stripe_plan_id;

          localStorage.setItem("user", JSON.stringify(userStoreInfo));
          this.$store.dispatch("updateUser", userStoreInfo);
        })
        .catch(e => {
          this.showError(e);
        });
    },*/
    closePaymentPopup(status = null){
      if (status == 'failed') {
        this.paymentPopUp = false;
        this.company = false;
        this.account = true;
        this.leavetype = false;
      }
      if (status == 'success') {
        this.paymentPopUp = false;
        if (this.$route.query.map_id) {
          this.getSubcriptionDetl(this.$route.query.map_id);
        }else{
          // this.logout();
        }
        // this.$router.push({ name: "organizationDashboard" });
      }
    },
    async getSubcriptionDetl(map_id) {
      this.$vs.loading({ color: "primary" });
      let input = {
        map_id: map_id
      };
      await this.axios
        .get("getSubcriptionDetails",{ params: input })
        .then(response => {
          if (response) {   
            let loginUser = response.data.data.loginUser;
            this.$store.dispatch("updateUserSubscriptionPlan", loginUser);
            this.$vs.loading.close();
            return true;
          }
        })
        .catch(e => {
          this.showError(e, "#data-addupdate");
          return false;
        });
    },
  }
};
</script>
<style>
.payment-check svg {
  width: 70px;
  height: 70px;
}
.payment-popup > .vs-popup{
  width: 400px !important;
}
.payment-popup > .vs-popup--background{
  pointer-events: none !important;
}
</style>